export const comments_5150485 = {"data":{"data":[],"links":{}}}